import { render } from "./LevelingGenderView.vue?vue&type=template&id=576aca5c&ts=true"
import script from "./LevelingGenderView.vue?vue&type=script&lang=ts"
export * from "./LevelingGenderView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__